import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { token } from 'odyssey';

export const FeaturedLinkWrapper = styled.div<{ background: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
  width: 100%;
  margin: 60px 0px 60px 0px;
  padding: 50px 50px 50px 30px;
  ${({ background, theme }) =>
    !background &&
    css`
      background-color: ${theme.customColors.tertiary};
    `};
  ${media.md`
    margin: 60px 0px 40px 0px;
    padding-left: 50px;
  `};
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right, rgba(51, 51, 51, 0.5), rgba(51, 51, 51, 0));
  }
`;

export const FeaturedLinkInnerWrapper = styled.div`
  z-index: 1;
  max-width: 440px;
  color: ${token('color-white')};
`;

export const Title = styled.h3`
  margin: 0 0 ${token('space-3')} 0;
  font-weight: ${token('font-weight-md')};
  color: inherit;
  text-transform: uppercase;
`;

export const Subtitle = styled.p`
  margin: 10px 0 30px 0;
  font-family: var(--sf-header-font);
  font-size: ${token('font-size-lg')};
  line-height: ${token('line-height-3xl')};

  ${media.md`
    margin-top: 0;
    font-size: ${token('font-size-3xl')};
    line-height: ${token('line-height-4xl')}
  `};
`;
